import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const LogoIcon = ({
    fill = variables['colors-mc-logo-1'],
    fill2 = variables['colors-mc-logo-2'],
    width = 60,
    height = 60,
    viewBox = '0 0 60 60',
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={remCss(width)}
      height={remCss(height)}
      viewBox={viewBox}
    >

      <path
        d="M30 59.9999H1.79523L8.5907 51.0152C3.7371 46.0706 0.744654 39.5983 0.121588 32.6977C-0.501478 25.7971 1.28325 18.8936 5.17266 13.1595C9.06207 7.42548 14.8164 3.2145 21.4583 1.24173C28.1002 -0.731041 35.2202 -0.343959 41.6091 2.33723C47.998 5.01842 53.2618 9.82841 56.5067 15.9503C59.7515 22.0722 60.7773 29.1285 59.4098 35.9209C58.0424 42.7133 54.3659 48.823 49.0049 53.2123C43.6438 57.6016 36.9287 59.9999 30 59.9999Z"
        fill={fill}/>
      <path
        d="M30.0001 0V60C33.9397 60 37.8408 59.224 41.4806 57.7164C45.1203 56.2087 48.4275 53.999 51.2133 51.2132C53.999 48.4274 56.2088 45.1203 57.7165 41.4805C59.2241 37.8407 60.0001 33.9397 60.0001 30C60.0001 26.0603 59.2241 22.1593 57.7165 18.5195C56.2088 14.8797 53.999 11.5726 51.2133 8.7868C48.4275 6.00104 45.1203 3.79125 41.4806 2.28361C37.8408 0.775973 33.9397 -5.87054e-08 30.0001 0Z"
        fill={fill2}/>
      <path
        d="M27.6003 42H32.3998V32.3998H42.0001V27.6002H32.4009V18H27.6013V27.6002H18.0001V32.3998H27.6003V42Z"
        fill="white"/>

    </svg>
  );
export default LogoIcon;
